import axios from "axios";

const getBaseURL = (database: string) => {
  const mappings = {
    eugra: "eucgr",
    piabi: "pabies",
    plantgenie: "potrav2",
    potri: "potri"
  };
  const mapped = mappings[database] || "potrav2"; // default to potrav2
  return `https://enrichment.plantgenie.org/${mapped}/enrichment`;
};

export async function getEnrichmentData(database: string, geneList) {
  const baseURL = getBaseURL(database);
  const axiosClient = axios.create({ baseURL: baseURL });
  return axiosClient.post("", {
    target: ["go", "pfam", "kegg"],
    genes: geneList,
    include_defs: false,
    alpha: 1,
  });
}

export async function sendDataToRevigo(data) {
  return axios.post("http://revigo.irb.hr", data);
}
